import { ReactElement } from 'react'
import { useParams } from 'react-router'
import { ProjectApplicationAssessmentExclusion } from 'src/screens/shared/application/assessment/details/exclusion/ProjectApplicationAssessmentExclusion'

export const PfKapExclusionPage = (): ReactElement => {
  const { projectId, assessmentId } = useParams()
  const pfKapProjectId = parseInt(projectId as string)
  const pfKapAssessmentId = parseInt(assessmentId as string)

  return (
    <ProjectApplicationAssessmentExclusion
      baseUrl="/pf-kap"
      projectId={pfKapProjectId}
      assessmentId={pfKapAssessmentId}
    />
  )
}
